import { Grid, Typography, Card, CardContent } from '@mui/material';

export const StepPrivacyNotice = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container spacing={6}>
              <Grid item xs={6}>
                <Typography variant='h6'>Important information and who we are</Typography>
                <Typography align='justify' paragraph>
                  Your personal information will be collected and processed by Insignia Cards Limited, registration number C 54426, with address at
                  Level 10, Q2, Quad Central, Central Business District, Birkirkara, CBD 1040. We are part of a family of companies known as The
                  Insignia Group of Companies as defined in our full Privacy Notice. More information on us and the Group can be found at
                  www.insignia-cards.com.
                </Typography>
                <Typography variant='h6'>The data we collect about you</Typography>
                <Typography align='justify' paragraph>
                  Personal data, or personal information, means any information about an individual from which that person can be identified. We may
                  collect, use, store and transfer different kinds of personal data about you which we have grouped together in categories such as
                  Identity, Financial and Contact data. You can find further details about these categories in our full Privacy Notice.
                </Typography>
                <Typography variant='h6'>How is your personal data collected</Typography>

                <Typography align='justify'>We will collect personal information about you from a number of sources including:</Typography>
                <Typography align='justify'>
                  • information given to us on application forms, in letters and emails, over the phone or through the device you use.
                </Typography>
                <Typography align='justify'>
                  • from analysis of how you operate our products and services, including the frequency, nature, location, origin and recipients of
                  any payments.
                </Typography>
                <Typography align='justify'>
                  from, or through, other organisations (for example other entities within the Insignia Group of Companies, card associations,
                  insurance companies, retailers, social media, credit reference agencies, fraud prevention agencies and public information sources).
                </Typography>
                <Typography align='justify'>
                  • in certain circumstances we may also use special categories of your data (criminal convictions) but we will only do this where
                  allowed by law or if you give your consent.
                </Typography>
                <Typography align='justify' paragraph>
                  For more information about how your personal information is collected, see our full Privacy Notice.
                </Typography>
                <Typography variant='h6'>How we use your personal information</Typography>
                <Typography align='justify'>We will use your personal information:</Typography>
                <Typography align='justify'>
                  • to provide products and services, manage your relationship with us and comply with any laws or regulations we are subject to (for
                  example the laws that prevent financial crime or the regulatory requirements governing the products we offer).
                </Typography>
                <Typography align='justify'>
                  • for other purposes including improving our services, exercising our rights in relation to agreements and contracts and identifying
                  products and services that may be of interest.
                </Typography>
                <Typography align='justify'>
                  To support us with the above we analyse information we know about you and how you use our products and services. We do not use your
                  data to make any automated decisions about you. You can find out more about how we use your information, and in what circumstances
                  you can ask us to stop, in our full Privacy Notice.
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='h6'>Who we share your personal information with</Typography>
                <Typography align='justify' paragraph>
                  Your personal information will be shared within the Insignia Group of Companies and other companies that provide services to you or
                  us, so that we and any other companies in the Group can look after your relationship with us. By sharing this information it enables
                  us to run accounts and policies, and provide products and services efficiently. This processing may include activities which take
                  place outside of the European Economic Area. If this is the case we will ensure appropriate safeguards are in place to protect your
                  personal information. You can find out more about how we share your information in our full Privacy Notice.
                </Typography>
                <Typography variant='h6'>Do you have to give us your personal information</Typography>
                <Typography align='justify' paragraph>
                  We may be required by law, or as a consequence of any contractual relationship we have, to collect certain personal information. If
                  you fail to provide this information to us it may prevent or delay us fulfilling these obligations or performing services which may
                  prevent us operating accounts or policies.
                </Typography>
                <Typography variant='h6'>What rights you have over your personal information</Typography>
                <Typography align='justify'>The law gives you a number of rights in relation to your personal information including:</Typography>
                <Typography align='justify'>• To request access to your personal data</Typography>
                <Typography align='justify'>• To request correction of your personal data</Typography>
                <Typography align='justify'>• To request erasure of your personal data</Typography>
                <Typography align='justify'>• To object to processing of your personal data</Typography>
                <Typography align='justify'>• To request restriction of processing your personal data</Typography>
                <Typography align='justify'>• To request transfer of your personal data</Typography>
                <Typography align='justify'>• To withdraw consent</Typography>
                <Typography align='justify' paragraph>
                  You can find out more about these rights and how you can exercise them in our full Privacy Notice.
                </Typography>
                <Typography variant='h6'>How long we keep your information for</Typography>
                <Typography align='justify' paragraph>
                  We will keep your information for as long as you are a customer of Insignia Cards Limited. After you stop being a customer, we may
                  keep your data for up to 10 years. You can find out more about our retention policy in our full Privacy Notice.
                </Typography>
                <Typography variant='h6'>Our full data Privacy Notice</Typography>
                <Typography align='justify' paragraph>
                  It is important that you understand how the personal information you give us will be used. Therefore, we strongly advise that you
                  read our full Privacy Notice which can be found at www.insignia-cards.com. or you can ask us for a copy
                </Typography>
                <Typography variant='h6'>If you would like to contact us or exercise any of your rights</Typography>
                <Typography align='justify' paragraph>
                  If you have any questions, require more information about how we use your personal information, or wish to exercise any of your
                  rights, please contact our Data Protection Officer on dpo@insignia-cards.com. You also have the right to make a complaint at any
                  time to the Office of the Information and Data Protection Commissioner, which you can do so on their website (www.idpc.org.mt).
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
